import React from "react";
import DiscussWrapper from "./discuss.style";
import { DISCUSS_FORUM_URL } from "../../constants/links";
import Discuss from "../../assets/images/meshery-learn-logo-white.png";

const DiscussCallout = () => {
  return (
    <DiscussWrapper>
      <div className="explain">
        <div className="cards">
          <div className="card">
            <a href={DISCUSS_FORUM_URL} target="_blank" rel="noopener noreferrer">
              <div className="parentcard">
                <div className="section-title">
                  <h2>Join the Conversation</h2>
                  <p>Ask questions, find answers and share knowledge on our Discussion Forum</p>
                  <button><img className="logo" alt="Discussion Forum" src={Discuss} /></button>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </DiscussWrapper>
  );
};

export default DiscussCallout;
